<template>
  <div class="column">
    <div class="video-collection-item columns is-gapless">
      <div class="column">
        <div class="content">
                <star-series :series="item"></star-series>
                <router-link :to="{name: 'videoSeries', params:{sid: item.id}}">
                  <h3>{{item.pagetitle}}</h3>
                </router-link>
                <hr>
                <p class="teacher-tag">
                    <router-link v-for="teacher in teachers" :key="teacher.id"
                    :to="{name: 'teacherPage', params:{tid: teacher.id}}">
                    {{teacher.name}}
                    </router-link>
                </p>
                <hr>
                <p>
                  <current-tag v-for="current in currentList" :current="current"
                :base="$store.state.initialData.basepath" :key="current.id" class="s-current">
                </current-tag>
                </p>
                <hr>
                <p>{{videoList.length}} שיעורים</p>
            </div>
      </div>
      <div class="column">
        <router-link :to="{name: 'videoSeries', params:{sid: item.id}}">
            <figure class="image is-square">
                <img :src="imgUrl" :alt="item.pagetitle">
            </figure>
          </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import CurrentTag from "@/components/CurrentTag.vue";
import StarSeries from "./StarSeries.vue";

export default {
  name: `CollectionItem`,
  components: {
    StarSeries,
    CurrentTag
  },
  props: {
    item: Object
  },

  computed: {
    imgUrl() {
      const base = this.$store.state.initialData.basepath;
      const path = `assets/yoga/images/videos/`;
      const image = this.item.gvImage.trim();
      return `${base}${path}${image}`;
    },
    teachers() {
      const output = {};
      if (Array.isArray(this.item.videoList)) {
        this.item.videoList.forEach((v) => {
          this.$store.state.initialData.teachers.forEach((t) => {
            if (t.id === v.videoTeacher) {
              output[t.id] = t;
            }
          });
        });
      }
      return Object.values(output);
    },
    videoList() {
      if (typeof this.item.videoList !== `undefined`) {
        return this.item.videoList;
      }
      return [];
    },

    currentList() {
      const arr = [];
      const output = [];
      this.videoList.forEach((video) => {
        if (arr.indexOf(video.current) === -1) {
          arr.push(video.current);
        }
      });

      arr.forEach((c) => {
        if (typeof this.getCurrent(c) !== `undefined`) {
          output.push(this.getCurrent(c));
        }
      });
      return output;
    }
  },

  methods: {
    getCurrent(current) {
      if (Array.isArray(this.$store.state.currents)) {
        const arr = this.$store.state.currents.filter((c) => {
          if (typeof c.resource !== `undefined` && c.resource.id === current) {
            return true;
          }
          return false;
        });

        return arr[0];
      }
      return {};
    }
  }
};
</script>

<style lang="scss">
$black: #191919;
$crimsonish: #976177;

.video-collection-item {
  background-color: #ffffff;
  max-width: 424px;
  margin-bottom: 1.5rem;
  .content {
    padding: 0.7rem;
    h3 {
      font-size: 1rem;
      color: $black;
      font-weight: 300;
    }
    hr {
      margin: 0.5rem auto;
    }
    p {
      margin: 0 !important;
      font-size: 0.8rem;
    }
    .teacher-tag {
      font-size: 0.8rem;
      a {
        color: $crimsonish;
      }
    }
  }
}

@media screen and (min-width: 385px) {
  .video-collection-item {
    min-width: 384px;
  }
}
</style>
